import { Expose } from "class-transformer";

export class CreateProjectHasCertificationDto {
  @Expose()
  projectId: string;

  @Expose()
  certificationId: string;
}
